import { render, staticRenderFns } from "./BasicWorkflowCanvas.vue?vue&type=template&id=6b0bf65c&scoped=true"
import script from "./BasicWorkflowCanvas.vue?vue&type=script&lang=js"
export * from "./BasicWorkflowCanvas.vue?vue&type=script&lang=js"
import style0 from "./BasicWorkflowCanvas.vue?vue&type=style&index=0&id=6b0bf65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bf65c",
  null
  
)

export default component.exports